module.exports = __webpack_public_path__ + "img/pnglogo.a15fff32.png";